import React from 'react';
import { motion } from 'framer-motion';
import { packages } from '../../data/packages';
import { PackageCard } from '../packages/PackageCard';
import { Gift } from 'lucide-react';

export const Packages: React.FC = () => {
  return (
    <section id="packages" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-64 h-64 bg-red-600 rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-green-600 rounded-full translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4">
            Choose Your Santa Package 🎅✨
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bring the magic of Santa Claus to life with personalized videos for your loved ones. 
            Pick the package that suits your holiday needs!
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {packages.map((pkg, index) => (
            <motion.div
              key={pkg.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <PackageCard 
                package={pkg}
                featured={pkg.id === 'family'}
              />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-center space-y-6"
        >
          <p className="text-gray-600">
            All videos are 30 seconds long and include custom messages tailored to your recipients.
          </p>
          <p className="text-lg font-semibold text-gray-800">
            Need help deciding? Our Family Package is perfect for most customers!
          </p>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 inline-block">
            <p className="flex items-center text-red-700 font-semibold">
              <Gift className="w-5 h-5 mr-2" />
              Limited-Time Holiday Pricing—Offer ends December 20th!
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};